import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Sie müssen den Unternehmen, bei denen Sie als \"Administrator\" festgelegt sind, einen neuen Administrator zuordnen "),
  /*#__PURE__*/_createElementVNode("li", null, "Sie werden von allen Unternehmen entfernt"),
  /*#__PURE__*/_createElementVNode("li", null, "Sie setzen ein neues Verschlüsselungspasswort"),
  /*#__PURE__*/_createElementVNode("li", null, " Sie müssen von den Administratoren aller Unternehmen erneut zum Unternehmen hinzugefügt werden ")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }

import CenteredCard from "@/components/CenteredCard.vue";
import CoreIcon from "@/components/CoreIcon.vue";
import ListTile from "@/components/ListTile.vue";
import UButton from "@/components/UButton.vue";
import { CareProviderGroup } from "@/interfaces/careProviderGroup";
import { Profile } from "@/interfaces/profile";
import { CareProviderGroupRequests } from "@/helpers/requestHelpers/careProviderGroupRequests";
import { useSessionStore } from "@/store/sessionStore";
import { supabase } from "@/helpers/supabase";
import { ref, onMounted } from "vue";
import LogoutLink from "@/modules/Settings/components/LogoutLink.vue";
import { useAccountStore } from "@/store/accountStore";

import { saveEncryptionPassword } from "@/helpers/requestHelpers/profileRequests";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordFlowView',
  setup(__props) {

const step = ref<number>(0);
const newPassword = ref<string>("");

const myCareProviderGroups = ref<
  | {
      careProviderGroup: CareProviderGroup & {
        careProvider_careProviderGroup: Array<{
          profile: Profile;
        }>;
      };
      connectedProfiles: Profile[];
    }[]
  | null
>(null);

async function loadCareProviderGroupsOwner() {
  const sessionStore = useSessionStore();

  const careProviderGroups = (
    await supabase
      .from("careProviderGroup")
      .select(
        `
        id,
      group_name,
      owner,
      short_name,
      color,
      address1,
      address2,
      city,
      zip, 
      is_orderer,
      is_shop,
      created_at,
      careProvider_careProviderGroup(
        profile(*)
      )
  `
      )
      .eq("owner", sessionStore.session?.user.id)
      .returns<
        Array<
          CareProviderGroup & {
            careProvider_careProviderGroup: Array<{ profile: Profile }>;
          }
        >
      >()
  ).data;
  if (careProviderGroups) {
    myCareProviderGroups.value = [];
    for (const cpg of careProviderGroups) {
      let profiles: Profile[] = [];
      for (const cp_cpg of cpg.careProvider_careProviderGroup) {
        if (cp_cpg.profile.id == sessionStore.session?.user.id) continue;
        if (profiles.findIndex((p) => p.id == cp_cpg.profile.id) == -1) {
          profiles.push(cp_cpg.profile);
        }
      }
      const newEntry = {
        careProviderGroup: cpg,
        connectedProfiles: profiles,
      };

      if (profiles.length == 0) {
        myCareProviderGroups.value = [newEntry];
        step.value = -1;
        return;
      }

      myCareProviderGroups.value.push(newEntry);
    }
  }
}

async function changeOwner(careProviderGroupId: number, profileId: string) {
  await new CareProviderGroupRequests().changeOwnerOfCareProviderGroup(
    careProviderGroupId,
    profileId
  );
  await loadCareProviderGroupsOwner();
  window._paq.push(["trackEvent", "ResetPasswordFlow", "changeOwner"]);
}

async function resetProfile() {
  const myId = useSessionStore().session?.user.id;
  await supabase
    .from("careProvider_careProviderGroup")
    .delete()
    .eq("care_provider_id", myId); // remove from accounts

  await supabase.from("profile_publicKey").delete().eq("user_id", myId); // remove from accounts
  step.value = 2;
  window._paq.push(["trackEvent", "ResetPasswordFlow", "resetProfile"]);
}

async function setNewPassword() {
  let result = await saveEncryptionPassword(newPassword.value);
  if (result.error) throw result.error;
  step.value = 3;
  window._paq.push(["trackEvent", "ResetPasswordFlow", "setNewPassword"]);
}
async function finish() {
  useSessionStore().password = newPassword.value;

  await useAccountStore().loadProfile();
  window._paq.push(["trackEvent", "ResetPasswordFlow", "complete"]);
}
function reload() {
  location.reload();
}

onMounted(() => {
  loadCareProviderGroupsOwner();
  window._paq.push(["trackEvent", "ResetPasswordFlow", "open"]);
});

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(CenteredCard, null, {
    default: _withCtx(() => [
      (step.value == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(" Mit Ihrem Passwort wurden alle Zugriffe auf die Daten der Patienten verschlüsselt. Nicht einmal unsere Techniker können Ihre Daten so lesen oder für Sie wiederherstellen. Falls Sie Ihr Passwort zurücksetzen wollen, müssen Sie deshalb folgende Schritte durchlaufen. "),
            _hoisted_2,
            _createVNode(UButton, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value = 1)),
              class: "w-full mt-s"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Fortfahren")
              ]),
              _: 1
            }),
            _createVNode(LogoutLink, { class: "mt-s" })
          ]))
        : (
        step.value == 1 && myCareProviderGroups.value && myCareProviderGroups.value.length > 0
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(" Bitte wählen Sie eine:n andere:n Administrator:in für Ihr Unternehmen. Diese:r kann Sie nach dem Zurücksetzen Ihres Profils wieder einladen. "),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myCareProviderGroups.value, (careProviderGroup) => {
                  return (_openBlock(), _createBlock(ListTile, {
                    key: careProviderGroup.careProviderGroup.id
                  }, {
                    main: _withCtx(() => [
                      _createTextVNode(_toDisplayString(careProviderGroup.careProviderGroup.group_name) + " ", 1),
                      _hoisted_4,
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(careProviderGroup.connectedProfiles, (profile) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: profile.id,
                            class: "flex"
                          }, [
                            _createTextVNode(_toDisplayString(profile.first_name) + " " + _toDisplayString(profile.last_name) + " ", 1),
                            _createVNode(CoreIcon, {
                              icon: "user-change",
                              onClick: ($event: any) => (
                    changeOwner(
                      careProviderGroup.careProviderGroup.id,
                      profile.id
                    )
                  )
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]))
          : (step.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(" Sie besitzen kein Unternehmen. Sie können Ihren Account nun zurücksetzen. Dadurch werden Sie von allen Unternehmen entfernt und müssen beim nächsten Login ein neues Verschlüsselungspasswort setzen. "),
                _createVNode(UButton, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (resetProfile())),
                  class: "w-full mt-s"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Profil zurücksetzen und alle Praxen entfernen")
                  ]),
                  _: 1
                })
              ]))
            : (step.value == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(" Ihr Account wurde zurückgesetzt. Sie können nun ein neues Passwort setzen. "),
                  _createVNode(_component_FormKit, {
                    type: "form",
                    "submit-label": "neues Passwort festlegen",
                    onSubmit: setNewPassword
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        type: "password",
                        modelValue: newPassword.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newPassword).value = $event)),
                        placeholder: "Neues Passwort",
                        validation: "required",
                        label: "Passwort",
                        name: "password"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormKit, {
                        type: "password",
                        label: "Passwort bestätigen",
                        name: "password_confirm",
                        validation: "required|confirm",
                        placeholder: "Neues Passwort"
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (step.value == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createTextVNode(" Ihr Account wurde zurückgesetzt und ihr neues Passwort gespeichert. Die neuen Administrator:innen können Sie nun wieder in Ihre Unternehmen einladen. "),
                    _createVNode(UButton, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (finish())),
                      class: "w-full mt-s"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Einloggen")
                      ]),
                      _: 1
                    })
                  ]))
                : (step.value == -1 && myCareProviderGroups.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createTextVNode(" Nur Sie haben Zugriff auf die Unternehmen " + _toDisplayString(myCareProviderGroups.value[0].careProviderGroup.group_name) + ". Dadurch kann niemand ausser Sie die Daten Ihrer Unternehmen ansehen. Ein Zurücksetzen des Passwortes ist deshalb nicht möglich. Bitte kontaktieren Sie uns, um weitere Hilfe zu erhalten. ", 1),
                      _createVNode(UButton, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (reload())),
                        class: "w-full mt-s"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Seite neuladen")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})